<template>
    <div>
        <breadcrumb class="px-4 bg-light pb-0" :items="breadcrumbs" />
        <div class="page-content">
            <list />
        </div>
    </div>
</template>

<script>
import Breadcrumb from "@/components/commons/breadcrumb.vue";
import List from "@/module/settings/discounts/list.vue";

export default {
    components: {
        Breadcrumb,
        List
    },
    computed: {
        breadcrumbs() {
            return [
                {
                    text: "Settings",
                    href: process.env.APPS + "business/business"
                },
                {
                    text: "Discounts",
                    href: "#"
                }
            ];
        }
    }
};
</script>
